@if (isMobileViewport() && !isExamRunning()) {
  <app-desktop-required [isTablet]="isTabletDevice()" [isSmallScreen]="isSmallScreen()" />
} @else {
  <router-outlet />
  <app-security-lock-overlay />
  <app-duplicate-tab-overlay />
  @if (isMobileViewport()) {
    <div class="fixed inset-0 z-[110] overflow-y-auto">
      <app-desktop-required [isTablet]="isTabletDevice()" [isSmallScreen]="isSmallScreen()" [duringExam]="true" />
    </div>
  }
}
